/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ComparisonsControllerRenameMutationResponse, ComparisonsControllerRenamePathParams, ComparisonsControllerRename400, ComparisonsControllerRename401, ComparisonsControllerRename403, ComparisonsControllerRename404 } from "../../models/comparisonsController/ComparisonsControllerRename";

function getComparisonsControllerRenameUrl(id: ComparisonsControllerRenamePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/comparisons/${id}` as const }  
  return res
}

/**
 * @summary Rename a comparison
 * {@link /api/v1/comparisons/:id}
 */
export async function comparisonsControllerRename(id: ComparisonsControllerRenamePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ComparisonsControllerRenameMutationResponse, ResponseErrorConfig<ComparisonsControllerRename400 | ComparisonsControllerRename401 | ComparisonsControllerRename403 | ComparisonsControllerRename404>, unknown>({ method : "PATCH", url : getComparisonsControllerRenameUrl(id).url.toString(), ... requestConfig })  
  return res.data
}